export default class GsmHelper {
    constructor() {
        this.gsmBasicChars = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
        this.gsmExtendedChars = '^{}\\\\[~]|€';
    }

    analyzeText(text) {

        const result = {
            isGsmCompatible: true,
            segmentLength: 160,
            extendedCharacters: [],
            length: 0,
        };

        if (!text) {
            return result;
        }

        const characters = text.split('');

        for (const character of characters) {
            if (this.isGsmBasicChar(character)) {
                result.length += 1;
            } else if (this.isGsmExtendedChar(character)) {
                result.length += 2;
                result.extendedCharacters.push(character);
            } else {
                result.isGsmCompatible = false;
                result.segmentLength = 70;
                result.length = this.getUnicodeCharacterCount(text);
                break;
            }
        }

        if (result.isGsmCompatible && result.length > 160) {
            result.segmentLength = 153;
        } else if (!result.isGsmCompatible && result.length > 70) {
            result.segmentLength = 67;
        }

        return result;
    }

    getUnicodeCharacterCount(text) {
        return Array.from(text).reduce((count, char) => {
            const codePoint = char.codePointAt(0);

            // Check if it's an emoji (most emojis are in these ranges)
            if (
                (codePoint >= 0x1F300 && codePoint <= 0x1F9FF) ||  // Miscellaneous Symbols and Pictographs
                (codePoint >= 0x2600 && codePoint <= 0x26FF) ||    // Miscellaneous Symbols
                (codePoint >= 0x2700 && codePoint <= 0x27BF) ||    // Dingbats
                (codePoint >= 0xFE00 && codePoint <= 0xFE0F) ||    // Variation Selectors
                (codePoint >= 0x1F000 && codePoint <= 0x1F255)  // Mahjong, Domino Tiles
            ) {
                return count + 2;
            }

            // Regular characters count as 1
            return count + 1;
        }, 0);
    }

    getCharacterCount(text) {
        return this.analyzeText(text).length;
    }

    getSmsCount(text) {
        if (!text) {
            return 0;
        }

        const gsmValidation = this.analyzeText(text);

        if (gsmValidation.length <= gsmValidation.segmentLength) {
            return 1;
        }

        return Math.ceil(gsmValidation.length / gsmValidation.segmentLength);
    }

    isGsmBasicChar(character) {
        return this.gsmBasicChars.includes(character);
    }

    isGsmExtendedChar(character) {
        return this.gsmExtendedChars.includes(character);
    }
};
